import lessRequire from '../../../../config/less-require-resolver';
import PropTypes from 'prop-types';
import React from 'react';
import classname from 'classname';

lessRequire('modules/news/components/filter/checkbox-type.less');

const CheckboxType = props => (
	<div className={classname({
		'checkbox-news-wrap': true,
		'is-checked': props.input.value
	})}>
		<div className="checkbox-news-type">
			<input
				type="checkbox"
				id={props.input.name}
				{...props.input} />
			<label htmlFor={props.input.name} className={props.className}/>
		</div>
		<label htmlFor={props.input.name} className="label-name font-proxima-nova-regular">
			{props.labelText}
		</label>
	</div>
);

CheckboxType.propTypes = {
	input: PropTypes.object,
	type: PropTypes.string,
	className: PropTypes.string,
	labelText: PropTypes.string
};

export default CheckboxType;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/news/components/filter/checkbox-type.js